import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "origin",
    "placeholder",
  ]

  update() {
    this.placeholderTarget.placeholder = this.originTarget.value
  }
}
